
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.016 16.983h3L16 12.023l-5.016 4.96h3v4.023h4.032v-4.023zm5.343-2.948c1.282.094 2.375.624 3.282 1.59.906.936 1.359 2.06 1.359 3.37 0 1.371-.5 2.557-1.5 3.555-.969.967-2.14 1.45-3.516 1.45H10c-1.656 0-3.078-.577-4.266-1.731C4.578 21.084 4 19.665 4 18.012c0-1.466.516-2.776 1.547-3.93 1.062-1.185 2.328-1.856 3.797-2.012a7.829 7.829 0 012.765-2.947A7.155 7.155 0 0116 8c1.688 0 3.25.593 4.688 1.778 1.468 1.185 2.359 2.604 2.671 4.257z"}})])
          )
        }
      }
    